import { useAuthState } from 'react-firebase-hooks/auth';
import usePromise from 'react-use-promise';

// ---------- In project imports ----------

import { auth } from './initFirebase';

import WelcomeScreen from "./WelcomeScreen";
import GameScreen from './GameScreen';

function App() {
	const authState = useAuthState(auth);
	const [user, userLoading, userError] = authState;

	const [token, tokenError, tokenState] = usePromise(
		() => user == null
			? Promise.resolve(undefined)
			: user.getIdTokenResult()
		, [user?.uid]);


	const isAdmin = token?.claims?.admin == true;	

	return user
		? <GameScreen user={user} isAdmin={isAdmin} />
		: <WelcomeScreen authState={authState} />;
};

export default App;
